var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('Header',{staticClass:"Header"}),_c('div',{staticClass:"main-content"},[_c('Sidebar',[(_vm.hasChildMenu)?_c('Navigation',{staticClass:"navigation"}):_vm._e(),_c('router-view',{staticClass:"router-view"})],1)],1),_c('Footer',{staticClass:"Footer"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }